__webpack_require__.p = "/reports-requisitions-details/onboarding/";